import { AppSettings, errorSettings } from './dev';

export const getFromClient = async () => {
  try {
    const settings = await fetch('/enrolments/appsettings.json');
    const json: AppSettings = await settings.json();

    return json;
  } catch (error) {
    return errorSettings;
  }
};
